export default __webpack_public_path__ + "static/media/1921.ab60e492.png";